import React from "react";
import { Badge, Alert } from "react-bootstrap";
import { Link } from "react-router-dom";
import ModuleDisplayBoolean from "../../modules/fieldsDisplay/ModuleDisplayBoolean";
import ModuleDisplayEmail from "../../modules/fieldsDisplay/ModuleDisplayEmail";
import ModuleDisplayPhone from "../../modules/fieldsDisplay/ModuleDisplayPhone";
import ModuleDisplayURL from "../../modules/fieldsDisplay/ModuleDisplayURL";
import ModuleDisplayColor from "../../modules/fieldsDisplay/ModuleDisplayColor";
import ModuleDisplayDate from "../../modules/fieldsDisplay/ModuleDisplayDate";
export default function StatsListing(props) {
  const {
    heading,
    items,
    clickable,
    className,
    border,
    specialBadge,
    style,
    highlight,
  } = props;
  const colors = ["teal", "pink", "info", "green", "orange", "yellow", "dark"];
  return (
    <div className={`mb-0 details  ${className ? "" : "details"} ${border}`}>
      {heading && (
        <span className="badge headerText badge-light bgCream text-dark  p-2  font-small d-flex">
          {heading}
        </span>
      )}
      {clickable ? (
        <>
          {items.map((item, index) => {
            return (
              <div key={index}>
                <>
                  <Link
                    title="Please click to view"
                    to={item.url}
                    className="badge badge-light me-1 ms-1 mt-1 text-dark text-decoration-none p-2 font-small"
                  >
                    {item.title} :&nbsp;
                    {item.type === "text" ? (
                      <span className="text-secondary font-small ms-2">
                        {item.value}
                      </span>
                    ) : (
                      <Badge bg={colors[index]} className="ms-2" pill>
                        {item.value}
                      </Badge>
                    )}
                  </Link>
                </>
              </div>
            );
          })}
        </>
      ) : (
        items.map((item, index) => {
          return (
            <div key={index}>
              <>
                {item.hobby ? (
                  <Badge
                    bg="light"
                    className=" ms-1 text-dark mt-1 mb-1 p-2 font-small d-flex cursor-normal"
                  >
                    <span className="text-secondary font-small">
                      {item.hobby}
                    </span>
                  </Badge>
                ) : (
                  <Badge
                    bg={item.highlight === true ? "yellow" : "light"}
                    className={
                      specialBadge
                        ? `${specialBadge} me-1 text-dark mt-1 mb-1 p-2 font-small d-flex cursor-normal`
                        : " badge-custom-5 me-1 text-dark mt-1 mb-1 p-2 font-small d-flex cursor-normal"
                    }
                  >
                    {item.text} 
                    {item.text ? <>{"\t"}:</> : null}

                    {item.type === "boolean" ? (
                      <span className="text-secondary font-small ms-2 cursor-normal">
                        <ModuleDisplayBoolean
                          value={item.value}
                          trueValue={item.trueValue}
                          falseValue={item.falseValue}
                        />
                      </span>
                    ) : item.type === "text" ? (
                      <span className="text-secondary font-small ms-2 cursor-normal">
                        {item.value}
                      </span>
                    ) : item.type === "email" ? (
                      <span className="text-secondary font-small ms-2 cursor-normal">
                        <ModuleDisplayEmail value={item.value} />
                      </span>
                    ) : item.type === "color" ? (
                      <span className="text-secondary font-small ms-2 cursor-normal">
                        <ModuleDisplayColor value={item.value} />
                      </span>
                    ) : item.type === "phone" ? (
                      <span className="text-secondary font-small ms-2 cursor-normal">
                        <ModuleDisplayPhone value={item.value} />
                      </span>
                    ) : item.type === "date" ? (
                      <span className="text-custom-4 font-small ms-2 cursor-normal">
                        <ModuleDisplayDate value={item.value} />
                      </span>
                    ) : item.type === "link" ? (
                      <span className="text-secondary font-small ms-2 cursor-normal">
                        <ModuleDisplayURL
                          value={item.value}
                          download={item.download ? true : false}
                          title={item.title}
                        />
                      </span>
                    ) : (
                      <Badge
                        bg={colors[index]}
                        className="ms-2 cursor-normal"
                        pill
                      >
                        {item.value}
                      </Badge>
                    )}
                  </Badge>
                )}
              </>
            </div>
          );
        })
      )}
    </div>
  );
}
